import { computed } from "vue";
import { useFlowType } from "./flow-type";
import { EClaimMessagesKeys, ECaseMessagesKeys } from "../types";

export const useClaimCaseLabels = () => {
  const { isAttorneyFlow } = useFlowType();

  const labels = computed(() => {
    if (isAttorneyFlow.value) {
      return {
        // Step title
        TITLE: ECaseMessagesKeys.TITLE,
        TABNAME: ECaseMessagesKeys.TABNAME,

        // Form block titles
        DETAILS_BLOCK_TITLE: ECaseMessagesKeys.CASE_DETAILS_BLOCK_TITLE,
        DETAILS_SUBTITLE: ECaseMessagesKeys.CASE_DETAILS_SUBTITLE,
        ADDITIONAL_INFO_BLOCK_TITLE:
          ECaseMessagesKeys.ADDITIONAL_INFO_BLOCK_TITLE,

        // Field labels
        ACCIDENT_DATE_TITLE: ECaseMessagesKeys.ACCIDENT_DATE_TITLE,
        NUMBER_TITLE: ECaseMessagesKeys.CASE_NUMBER_TITLE, // "Case number"
        LICENSE_PLATE_TITLE: ECaseMessagesKeys.LICENSE_PLATE_TITLE,
        VIN_TITLE: ECaseMessagesKeys.VIN_TITLE,
        DRIVER_FIRST_NAME_TITLE: ECaseMessagesKeys.DRIVER_FIRST_NAME_TITLE,
        DRIVER_LAST_NAME_TITLE: ECaseMessagesKeys.DRIVER_LAST_NAME_TITLE,

        // Placeholders
        LICENSE_PLATE_PLACEHOLDER: ECaseMessagesKeys.LICENSE_PLATE_PLACEHOLDER,
        VIN_PLACEHOLDER: ECaseMessagesKeys.VIN_PLACEHOLDER,
        DRIVER_FIRST_NAME_PLACEHOLDER:
          ECaseMessagesKeys.DRIVER_FIRST_NAME_PLACEHOLDER,
        DRIVER_LAST_NAME_PLACEHOLDER:
          ECaseMessagesKeys.DRIVER_LAST_NAME_PLACEHOLDER,

        // Consent
        CONSENT_TEXT: ECaseMessagesKeys.CONSENT_TEXT,
        CONSENT_ACKNOWLEDGEMENT_TEXT:
          ECaseMessagesKeys.CONSENT_ACKNOWLEDGEMENT_TEXT,

        // Summary
        SUMMARY_INFO_TITLE: ECaseMessagesKeys.SUMMARY_CASE_INFO_TITLE,
        SUMMARY_DATE_OF_ACCIDENT: ECaseMessagesKeys.SUMMARY_DATE_OF_ACCIDENT,

        // Congrats
        CONGRATS_SUBTITLE: ECaseMessagesKeys.CONGRATS_SUBTITLE,
      };
    }

    // Default: TPA/Claim flow
    return {
      // Step title
      TITLE: EClaimMessagesKeys.TITLE,
      TABNAME: EClaimMessagesKeys.TABNAME,

      // Form block titles
      DETAILS_BLOCK_TITLE: EClaimMessagesKeys.CLAIM_DETAILS_BLOCK_TITLE,
      DETAILS_SUBTITLE: EClaimMessagesKeys.CLAIM_DETAILS_SUBTITLE,
      ADDITIONAL_INFO_BLOCK_TITLE:
        EClaimMessagesKeys.ADDITIONAL_INFO_BLOCK_TITLE,

      // Field labels
      ACCIDENT_DATE_TITLE: EClaimMessagesKeys.ACCIDENT_DATE_TITLE,
      NUMBER_TITLE: EClaimMessagesKeys.CLAIM_NUMBER_TITLE, // "Claim number"
      LICENSE_PLATE_TITLE: EClaimMessagesKeys.LICENSE_PLATE_TITLE,
      VIN_TITLE: EClaimMessagesKeys.VIN_TITLE,
      DRIVER_FIRST_NAME_TITLE: EClaimMessagesKeys.DRIVER_FIRST_NAME_TITLE,
      DRIVER_LAST_NAME_TITLE: EClaimMessagesKeys.DRIVER_LAST_NAME_TITLE,

      // Placeholders
      LICENSE_PLATE_PLACEHOLDER: EClaimMessagesKeys.LICENSE_PLATE_PLACEHOLDER,
      VIN_PLACEHOLDER: EClaimMessagesKeys.VIN_PLACEHOLDER,
      DRIVER_FIRST_NAME_PLACEHOLDER:
        EClaimMessagesKeys.DRIVER_FIRST_NAME_PLACEHOLDER,
      DRIVER_LAST_NAME_PLACEHOLDER:
        EClaimMessagesKeys.DRIVER_LAST_NAME_PLACEHOLDER,

      // Consent
      CONSENT_TEXT: EClaimMessagesKeys.CONSENT_TEXT,
      CONSENT_ACKNOWLEDGEMENT_TEXT:
        EClaimMessagesKeys.CONSENT_ACKNOWLEDGEMENT_TEXT,

      // Summary
      SUMMARY_INFO_TITLE: EClaimMessagesKeys.SUMMARY_CLAIM_INFO_TITLE,
      SUMMARY_DATE_OF_ACCIDENT: EClaimMessagesKeys.SUMMARY_DATE_OF_ACCIDENT,

      // Congrats
      CONGRATS_SUBTITLE: EClaimMessagesKeys.CONGRATS_SUBTITLE,
    };
  });

  return {
    labels,
    isAttorneyFlow,
  };
};
